import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ReportList, ReportCategory, ReportDescription } from '../classes/report-table';

@Injectable({
  providedIn: 'root'
})
export class ReportService {
  private readonly apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  getReportList(): Observable<ReportList>;
  getReportList(category: string): Observable<ReportCategory>;
  getReportList(category: string, report: string): Observable<ReportDescription>;
  getReportList(category?: string, report?: string): Observable<ReportList | ReportCategory | ReportDescription> {
    let url = `${this.apiUrl}/report_list`;
    if (category) {
      url += `/${category.replace(/ /g, '_')}`;
      if (report) {
        url += `/${report.replace(/ /g, '_')}`;
      }
    }
    return this.http.get<ReportList | ReportCategory | ReportDescription>(url);
  }

  getPublishTime(
    refinery: string,
    category: string,
    report: string,
    query: Record<string, string> = {}
  ): Observable<Record<string, unknown>[]> {
    return this.getAnyReport('PublishTime', refinery, category, report, query)
  }

  getMainReport(
    refinery: string,
    category: string,
    report: string,
    query: Record<string, string> = {}
  ): Observable<Record<string, unknown>[]> {
    return this.getAnyReport('report', refinery, category, report, query)
  }

  getAnyReport(
    type: 'report' | `PublishTime`,
    refinery: string,
    category: string,
    report: string,
    query: Record<string, string> = {}
  ): Observable<Record<string, unknown>[]> {
    let params = new HttpParams();
    for (const [key, value] of Object.entries(query)) {
      params = params.set(key, value ?? '');
    }

    const q = new URLSearchParams();
    // TODO(violeta): Fix this underscore slop
    q.append("refinery", refinery.replaceAll('_', ' '))
    q.append("category", category.replaceAll('_', ' '))
    q.append("report", report.replaceAll('_', ' '))
    q.append("query", type)

    const qs = q.toString();
    return this.http.get<Record<string, unknown>[]>(qs ? `${this.apiUrl}/report?${qs}` : `${this.apiUrl}/report`, { params });
  }

  getEndpointUrl(
    refinery: string,
    category: string,
    report: string,
    query: Record<string, string> = {}
  ): string {
    const q = new URLSearchParams();
    for (const [key, value] of Object.entries(query)) {
      q.append(key, value ?? '');
    }

    // TODO(violeta): Fix this underscore slop
    q.append("refinery", refinery.replaceAll('_', ' '))
    q.append("category", category.replaceAll('_', ' '))
    q.append("report", report.replaceAll(' ', '_'))
    q.append("query", "report")

    const qs = q.toString();
    return `${this.apiUrl}/report?${qs}`;
  }
}
